import { Module } from 'vuex';
import { rootState } from '../state';
import Vue from 'vue';
import { modalParams, snackbarParams } from '@/types/state.modal';


const state = {
    modal: {
        type: '',
        open: false,
        msg: '',
        defaultMsg: '',
    },
    image: {
        show: false,
        url: '',
    },
    snackbar: {
        type: '',
        open: false,
        msg: '',
        defaultMsg: '',
        align: {
            x: 'left',
            y: 'top'
        },
        mode: 'multi-line',
        timeout: 5000
    }
}

export const modalStateStore: Module<typeof state, typeof rootState> = {
    state,
    mutations: {
        ///info
        'modal:open'(state, param: modalParams) {
            state.modal.open = true
            state.modal.type = param.type
            state.modal.msg = param.msg
        },
        'modal:close'(state) {
            state.modal.open = false
            state.modal.type = ''
            state.modal.msg = ''
        },
        'image:show'(state, url: string) {
            state.image.show = true
            state.image.url = url
        },
        'image:hide'(state) {
            state.image.show = false
            state.image.url = ''
        },
        'snackbar:open'(state, param: snackbarParams) {
            state.snackbar.open = true
            state.snackbar.type = param.type
            state.snackbar.msg = param.msg
            if (param.align) {
                state.snackbar.align.x = param.align.x
                state.snackbar.align.y = param.align.y
            }
            if (param.mode) state.snackbar.mode = param.mode
        },
        'snackbar:close'(state) {
            state.snackbar.open = false
            state.snackbar.type = ''
            state.snackbar.msg = ''
            state.snackbar.align.x = 'left'
            state.snackbar.align.y = 'top'
            state.snackbar.mode = 'multi-line'
        }

    },
    actions: {
        'snackbar:after:open'(c, param: snackbarParams) {
            c.commit('snackbar:close');
            //setTimeout(() => c.commit('snackbar:open', param), 300)
            Vue.nextTick(() =>  c.commit('snackbar:open', param))
        }
    },
    getters: {
        modalState(state) {
            return state.modal.open
        },
        modalMsg(state) {
            return state.modal.msg
        }, 
        modalType(state) {
            return state.modal.type
        },
        imageState(state) {
            return state.image.show
        },
        snackbarState(state) {
            return state.snackbar.open
        },
        snackbarMsg(state) {
            return state.snackbar.msg
        }, 
        snackbarType(state) {
            return state.snackbar.type
        },
        snackbarAlignX(state) {
            return state.snackbar.align.x
        },
        snackbarAlignY(state) {
            return state.snackbar.align.y
        },
        snackbarMode(state) {
            return state.snackbar.mode
        },
        snackbarTimeout(state) {
            return state.snackbar.timeout
        }
    }
}